import { Box, Button, Container, Typography } from "@mui/material"
import { useHistory } from "react-router-dom/cjs/react-router-dom"
import { RealProperty } from "../salespage/realproperty/Index"
import { Product } from "../salespage/product/Index"
import { Service } from "../salespage/service/Index"
import { ServiceList } from "./service/ServiceList"
import { ProductList } from "./product/ProductList"
import { SalesPageList } from "./realproperty/SalesPageList"
import { ToolContext } from "../../../../core/context/ToolContext"
import { useContext, useEffect } from "react"
import { SnakeLoader } from "../../../../core/loader/SnakeLoader"
import { rqx } from "../../../../core/request/API"
import { env } from "../../../../core/Env"
import { ModalPromoMsg } from "../../../ubr/ubr_modals/PromoMsg"



const hcrmSession = JSON.parse(localStorage.getItem('hcrm_session'))
export const SalesPage = () => {
    const { tool_state, salespage_state, ubr_state } = useContext(ToolContext)
    const { __SESSION: { data: { ainfo, uaccess } }, listData, listLoader, capgueData, capgueMsg, modal_promo } = { ...tool_state, ...salespage_state, ...ubr_state }
    const urlParams = new URLSearchParams(window.location.search);
    const nav = useHistory()
    const sp = urlParams.get("type");
    const opt = urlParams.get("option");

    const Tab = () => {
        if (sp === 'property') {
            return <RealProperty opt={opt} />
        } else if (sp === 'service') {
            return <Service />
        } else if (sp === 'product') {
            return <Product />
        } else {
            return <Box height="100%" width="100%" border="1px solid #000" borderRadius={2} mt={2} p={8}>
                <Box height="100%" width="100%" display="flex" alignItems="center" justifyContent="center">
                    <Box fontSize={24} fontWeight={700}>404 NOT FOUND</Box>
                </Box>
            </Box>
        }
    }
    const optBtn = [
        { name: ' Real Property', url: 'property' },
        // { name: ' Service', url: 'service' },
        // { name: 'Product', url: 'product' },
    ]

    const tabHandler = (type) => {
        nav.push(`/campaign/sales_page?type=${type}`)
    }
    const createSalesPage = () => {
        nav.push('/campaign/sales_page?type=property&option=attract')
    }

    const __init = async () => {
        listLoader.set(true)
        const cafgu = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/read`,
            { tool_id: process.env.REACT_APP_TID_BIZ, user_id: parseInt(window.atob(ainfo.aid).split('_')[1]), ref: 'capgue' })
        capgueData.set(cafgu)

        const list = await rqx.get(`<<tool>>/${env()}/realProperty/readList`, { company_id: uaccess[0].company_id })
        listData.set({ ...listData.data, list, action: { selected: null, modal: false, type: 0, confirmed: false } })
        listLoader.set(false)
    }

    useEffect(() => {
        if (hcrmSession === null) {
            modal_promo.set(true)
        }
        __init()
        if (capgueData.data.length === 0) {
            capgueMsg.set(true)
        } else {
            capgueMsg.set(false)
        }


        // eslint-disable-next-line
    }, [])

    return (
        <Box width="100%" >
            {opt === null ?
                <>
                    <Box >
                        <Box display="flex" alignItems="center" gap={3} py={2}>
                            {
                                optBtn.map((v, k) => (
                                    <Box onClick={() => tabHandler(v.url)} key={k}
                                        width={150} border="solid 1px" component={Button} color={sp === v.url ? "#fff" : "#009F4D"} bgcolor={sp === v.url ? '#009F4D' : false} sx={{ ':hover': { bgcolor: '#009F4D', color: '#fff' }, borderRadius: "12px" }}>
                                        {v.name}
                                    </Box>
                                ))}
                        </Box>
                        <Box display="flex" alignItems="center" mt={4}>
                            <Box width="100%" fontSize={20} fontWeight={600}>{sp === "property" ? 'Real Property Sales Page Lists' : sp === "service" ? "Service" : 'Product'}</Box>
                            <Box width="100%" display="flex" justifyContent="end">
                            <Box disabled={listLoader.data === false && listData.data.list.length === 0} component={Button} variant='contained' bgcolor="#009F4D" fontSize={14} color="#fff" borderRadius={2} px={4} py={1} sx={{ ':hover': { bgcolor: '#009F4D', color: '#fff' } }} onClick={() => createSalesPage()}>
                                    {sp === "property" ? 'Create Real Property Page' : sp === "service" ? 'Create Service' : 'Create Product'}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                     <ModalPromoMsg />
                    <Box width="100%" mt={2} >
                        {sp === 'property' &&
                            <Box>
                                {
                                    listLoader.data ?
                                        <Box pt={15} display="flex" justifyContent="center" alignItems="center" flexDirection="column" my={5} >
                                            <SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
                                        </Box> :
                                        listData.data.list.length === 0 ?
                                            <Container maxWidth="md" >
                                                <Box pt={5}>
                                                <Box width="100%" display="flex" alignItems="center" flexDirection="column" p={5} sx={{ border: "solid 1px #009E6A", borderRadius: "8px"}}>
                                                    <Typography fontSize={16} fontWeight={550}>Click "Create Real Property Page" below to create your first real property page.</Typography>
                                                <Button variant='outlined' sx={{mt: 6, px: 5, height: 40, ":hover": { color: "#fff", bgcolor: 'green', border: "none" } }} onClick={() => createSalesPage()}>Create Real Property Page</Button>
                                                </Box>
                                                </Box>
                                            </Container>
                                            :
                                            hcrmSession !== null &&
                                            <SalesPageList ainfo={ainfo} listData={listData} listLoader={listLoader} __init={__init} capgueData={capgueData}/>
                                }
                            </Box>
                        }
                        {sp === "service" && <ServiceList />}
                        {sp === "product" && <ProductList />}
                    </Box>
                </>
                :
                <Box >
                    {Tab()}
                </Box>
            }

        </Box>
    )
}


